import { render } from "./AddInvestorModel.vue?vue&type=template&id=5002333d&scoped=true"
import script from "./AddInvestorModel.js?vue&type=script&lang=js"
export * from "./AddInvestorModel.js?vue&type=script&lang=js"

import "./AddInvestorModel.vue?vue&type=style&index=0&id=5002333d&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5002333d"]])

export default __exports__